import commonConfig from './common';
import devConfig from './development';
import prodConfig from './production';
import stagingConfig from './staging';

const env =
  (import.meta as ImportMeta & { env?: Record<string, string | boolean> }).env ??
  {};

const isTrue = (value: string | boolean | undefined) =>
  value === true || value === 'true';

const getConfig = () => {
  const isLocal = isTrue(env.DEV);
  if (isLocal) {
    return { ...commonConfig, ...devConfig };
  }

  // vercel deploy
  const branch = env.VITE_VERCEL_GIT_COMMIT_REF;
  if (branch) {
    switch (branch) {
      // explicitly setting configurations for specific branches for future flexibility,
      // such as renaming branches or adding new ones
      case 'main':
        return { ...commonConfig, ...prodConfig };
      case 'staging':
        return { ...commonConfig, ...stagingConfig };
      case 'dev':
        return { ...commonConfig, ...devConfig };
      default:
        return { ...commonConfig, ...prodConfig };
    }
  }

  // other platform deploy
  const isProd = isTrue(env.PROD);
  if (isProd) {
    return { ...commonConfig, ...prodConfig };
  }

  // default
  return { ...commonConfig, ...devConfig };
};

const config = getConfig();

export default config;
